module.exports = __webpack_public_path__ + "static/media/calculator.b56891cd.png";